// Tea Affair — Theme JavaScript
(function () {
  'use strict';

  // ─────────────────────────────────────────
  // Mobile menu
  // ─────────────────────────────────────────
  function initMobileMenu() {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.mobile-menu-toggle');
    if (!toggle || !header) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const open = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', String(open));
    });

    document.querySelectorAll('.nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ─────────────────────────────────────────
  // Cart count
  // ─────────────────────────────────────────
  function initCartCount() {
    var el = document.getElementById('cart-count');
    if (!el) return;

    function refresh() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { el.textContent = d.item_count; })
        .catch(function () {});
    }

    refresh();
    document.addEventListener('cart:updated', refresh);
  }

  // ─────────────────────────────────────────
  // AJAX Add-to-cart — intercepts every cart/add form
  // ─────────────────────────────────────────
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || typeof form.action !== 'string') return;
      if (form.action.indexOf('/cart/add') === -1) return;

      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      var originalDisabled = btn ? btn.disabled : false;

      if (btn) {
        btn.textContent = 'Adding…';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        if (btn) btn.textContent = 'Added!';

        // Refresh count + open mini cart
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var countEl = document.getElementById('cart-count');
            if (countEl) countEl.textContent = cart.item_count;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('mini-cart:open'));
          });

        setTimeout(function () {
          if (btn) {
            btn.textContent = originalText;
            btn.disabled = originalDisabled;
          }
        }, 2200);
      })
      .catch(function () {
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = originalDisabled;
        }
      });
    });
  }

  // ─────────────────────────────────────────
  // Anchor-link smooth scroll (interior pages)
  // ─────────────────────────────────────────
  function initAnchorScroll() {
    function ease(t) {
      return t < 0.5
        ? 8 * t * t * t * t
        : 1 - Math.pow(-2 * t + 2, 4) / 2;
    }

    function smoothScrollTo(targetY, duration) {
      var startY = window.scrollY;
      var distance = targetY - startY;
      var startTime = performance.now();

      function frame(now) {
        var progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, startY + distance * ease(progress));

        if (progress < 1) {
          requestAnimationFrame(frame);
        }
      }

      requestAnimationFrame(frame);
    }

    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = this.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();

        var snapEvent = new CustomEvent('fp-scroll:target', {
          cancelable: true,
          detail: { id: id, target: target }
        });
        if (!document.dispatchEvent(snapEvent)) return;

        var targetY = Math.round(target.getBoundingClientRect().top + window.scrollY);
        smoothScrollTo(targetY, 680);
      });
    });
  }

  function initNaturalWheelFallback() {
    var isHomepage = document.body.classList.contains('template-index');
    var hasSnapSections = document.querySelectorAll('[data-fp-snap]').length > 0;
    if (isHomepage || hasSnapSections) return;

    function hasScrollableParent(target, deltaY) {
      var el = target;
      while (el && el !== document.body && el !== document.documentElement) {
        if (el.nodeType !== 1) {
          el = el.parentNode;
          continue;
        }
        var style = window.getComputedStyle(el);
        var canScroll = /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight;
        if (canScroll) {
          if (deltaY > 0 && el.scrollTop + el.clientHeight < el.scrollHeight) return true;
          if (deltaY < 0 && el.scrollTop > 0) return true;
        }
        el = el.parentNode;
      }
      return false;
    }

    window.addEventListener('wheel', function (e) {
      if (e.defaultPrevented || !e.deltaY) return;
      if (hasScrollableParent(e.target, e.deltaY)) return;

      var startY = window.scrollY;
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      if (maxY <= 0) return;

      var deltaY = e.deltaY;
      if (e.deltaMode === 1) deltaY *= 16;
      if (e.deltaMode === 2) deltaY *= window.innerHeight;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (window.scrollY !== startY) return;
          if ((deltaY < 0 && startY <= 0) || (deltaY > 0 && startY >= maxY)) return;
          window.scrollBy(0, deltaY);
        });
      });
    }, { passive: true });
  }

  // ─────────────────────────────────────────
  // Full-page smooth scroll snap (homepage + page templates)
  // ─────────────────────────────────────────
  function initStandardMotion() {
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var sectionSelectors = [
      '.hero-section',
      '.product-showcase',
      '.product-detail',
      '.page-hero-section',
      '.image-text-section',
      '.values-section',
      '.timeline-section',
      '.page-content-section',
      '.collection-page-section',
      '.product-page-section',
      '.article-section',
      '.blog-section',
      '.contact-section',
      '.cart-page',
      '.qr-landing'
    ];

    var revealSelectors = [
      '.hero-lady',
      '.hero-title',
      '.hero-subtitle',
      '.hero-actions',
      '.showcase-eyebrow',
      '.showcase-title',
      '.showcase-description',
      '.showcase-buttons',
      '.product-can-single',
      '.product-info > *',
      '.product-hero-image',
      '.ph-content > *',
      '.it-image-col',
      '.it-text-col > *',
      '.values-header > *',
      '.value-card',
      '.timeline-header > *',
      '.timeline-item',
      '.page-content-header > *',
      '.page-content-divider',
      '.page-content-body',
      '.page-content-cta',
      '.collection-header-copy > *',
      '.collection-hero-media',
      '.collection-toolbar',
      '.product-card',
      '.product-page-gallery',
      '.product-page-info > *',
      '.article-header > *',
      '.article-featured-img',
      '.article-body',
      '.blog-header > *',
      '.blog-card',
      '.contact-info',
      '.contact-form-wrap',
      '.cart-header > *',
      '.cart-empty',
      '.cart-items-col',
      '.cart-summary-col',
      '.qr-landing-container > *'
    ];

    var sections = Array.from(document.querySelectorAll(sectionSelectors.join(',')));
    if (!sections.length) return;

    function markReveal(el, index) {
      if (!el || el.classList.contains('ta-reveal')) return;
      el.classList.add('ta-reveal');
      el.style.setProperty('--motion-index', index % 8);

      if (
        el.classList.contains('it-image-col') ||
        el.classList.contains('hero-lady') ||
        el.classList.contains('product-hero-image')
      ) {
        el.classList.add('ta-reveal--from-left');
      }

      if (
        el.classList.contains('product-can-single') ||
        el.classList.contains('value-card') ||
        el.classList.contains('product-card') ||
        el.classList.contains('blog-card')
      ) {
        el.classList.add('ta-reveal--scale');
      }
    }

    sections.forEach(function (section) {
      var revealEls = [];
      revealSelectors.forEach(function (selector) {
        section.querySelectorAll(selector).forEach(function (el) {
          if (revealEls.indexOf(el) === -1) revealEls.push(el);
        });
      });
      revealEls.forEach(markReveal);
    });

    function revealSection(section) {
      if (!section) return;
      section.classList.add('ta-motion-visible');
    }

    window.TeaAffairMotion = {
      revealSection: revealSection
    };

    if (reduceMotion) {
      sections.forEach(revealSection);
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealSection(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        threshold: 0.2,
        rootMargin: '0px 0px -8% 0px'
      });

      sections.forEach(function (section) {
        observer.observe(section);
      });
    } else {
      sections.forEach(revealSection);
    }

    requestAnimationFrame(function () {
      sections.forEach(function (section) {
        var rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.86 && rect.bottom > 0) {
          revealSection(section);
        }
      });
    });
  }

  function initFullPageScroll() {
    var isHomepage = document.body.classList.contains('template-index');
    var isPage     = document.body.classList.contains('template-page');

    // A long-form editorial section and full-page snapping are competing
    // navigation models. Keep these pages entirely native so users can move
    // through the story without a snap boundary taking over mid-scroll.
    if (isPage && document.querySelector('.image-text-section--long')) return;

    var snapEls;
    if (isHomepage) {
      snapEls = document.querySelectorAll('.hero-section, .product-showcase, .product-detail');
    } else if (isPage) {
      snapEls = document.querySelectorAll('[data-fp-snap]');
    }
    if (!snapEls || snapEls.length === 0) return;

    var sections = Array.from(snapEls);
    var footer = document.querySelector('.site-footer');
    if (footer) {
      sections.push(footer);
    }
    var header   = document.querySelector('.site-header');
    var current  = 0;
    var animating = false;
    var animSafetyTimer = null;
    var cancelAnimRaf = null;

    // Touch state
    var touchStartY    = 0;
    var touchStartX    = 0;
    var touchStartScrollY = 0;
    var touchIsVertical = null; // null = undecided, true = vertical, false = horizontal
    var lastTouchEndTime = 0;  // timestamp of most recent touchend
    var reSnapTimer = null;    // fires after momentum scrolling settles

    var lastWheelTime = 0;
    var lastWheelEventTime = 0;
    var wheelSamples = [];
    var DURATION    = 680;  // ms — scroll animation length
    var WHEEL_GAP   = 180;  // ms — ignore rapid wheel ticks
    var WHEEL_GESTURE_IDLE = 200; // ms — quiet gap before accepting another wheel gesture
    var WHEEL_SAMPLE_LIMIT = 150;
    var ANIM_SAFETY = DURATION + 600; // failsafe to clear stuck animating flag
    var RESNAP_SETTLE = 160; // ms of scroll silence before re-snapping after touch

    var fpDebug = /[?&]fpdebug=1\b/.test(window.location.search) ||
      window.localStorage.getItem('fpdebug') === '1';

    // Hand off scroll control from CSS to JS
    document.documentElement.classList.add('fp-scroll-active');
    document.documentElement.style.scrollSnapType = 'none';
    document.documentElement.style.scrollBehavior = 'auto';

    // Use visualViewport on mobile (accounts for iOS address bar shrink/grow)
    function viewportHeight() {
      return (window.visualViewport ? window.visualViewport.height : window.innerHeight);
    }

    function debugScroll(eventName, data) {
      if (!fpDebug || !window.console) return;
      data = data || {};
      data.current = current;
      data.animating = animating;
      data.scrollY = Math.round(window.scrollY);
      data.time = Date.now();
      console.log('[fp-scroll] ' + eventName, data);
    }

    function averageTail(values, count) {
      var start = Math.max(values.length - count, 0);
      var slice = values.slice(start);
      if (!slice.length) return 0;
      return slice.reduce(function (sum, value) { return sum + value; }, 0) / slice.length;
    }

    function isWheelAccelerating() {
      if (wheelSamples.length < 2) return true;
      return averageTail(wheelSamples, 10) >= averageTail(wheelSamples, 70);
    }

    // ── Easing: ease-in-out-quart ──────────
    function ease(t) {
      return t < 0.5
        ? 8 * t * t * t * t
        : 1 - Math.pow(-2 * t + 2, 4) / 2;
    }

    // ── Core scroll animation ──────────────
    // Returns a cancel function so callers can abort mid-flight.
    function animateTo(targetY, onDone) {
      var startY = window.scrollY;
      var dist   = targetY - startY;
      if (Math.abs(dist) < 1) { onDone && onDone(); return function () {}; }
      var t0 = performance.now();
      var rafId;
      var done = false;

      function frame(now) {
        if (done) return;
        var p = Math.min((now - t0) / DURATION, 1);
        window.scrollTo(0, startY + dist * ease(p));
        if (p < 1) {
          rafId = requestAnimationFrame(frame);
        } else {
          done = true;
          onDone && onDone();
        }
      }
      rafId = requestAnimationFrame(frame);

      return function cancel() {
        done = true;
        cancelAnimationFrame(rafId);
      };
    }

    function maxScrollY() {
      return Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
    }

    function isFooterSection(section) {
      return section && section.classList && section.classList.contains('site-footer');
    }

    function sectionTargetY(section) {
      var targetY = Math.round(section.getBoundingClientRect().top + window.scrollY);

      // A short footer can never align to the top of the viewport because the
      // document ends first. Snap to the page bottom instead so footer state
      // and swipe handling stay in sync.
      if (isFooterSection(section)) {
        return maxScrollY();
      }

      return Math.min(targetY, maxScrollY());
    }

    // ── Navigate to a section index ────────
    function goTo(index, direction) {
      debugScroll('goTo:request', { index: index, direction: direction });
      if (animating) return;
      if (index < 0) return;

      // Past last section → release to natural scroll (shows footer)
      if (index >= sections.length) {
        animating = false;
        debugScroll('goTo:release-end', { index: index, direction: direction });
        return;
      }

      clearTimeout(animSafetyTimer);
      clearTimeout(reSnapTimer);

      animating = true;
      current = index;
      if (window.TeaAffairMotion) window.TeaAffairMotion.revealSection(sections[index]);
      syncHeader();
      syncDots();

      var targetY = sectionTargetY(sections[index]);
      debugScroll('goTo:start', { index: index, direction: direction, targetY: targetY });

      cancelAnimRaf = animateTo(targetY, function () {
        // Re-snap to exact section top in case of sub-pixel rounding drift
        var exactY = sectionTargetY(sections[index]);
        if (Math.abs(window.scrollY - exactY) > 1) window.scrollTo(0, exactY);
        animating = false;
        cancelAnimRaf = null;
        clearTimeout(animSafetyTimer);
        debugScroll('goTo:done', { index: index, direction: direction });
      });

      // Failsafe: if the animation never calls onDone (e.g. tab was hidden
      // and rAF was suspended), unblock after a generous timeout.
      animSafetyTimer = setTimeout(function () {
        animating = false;
        cancelAnimRaf = null;
        debugScroll('goTo:safety-clear', { index: index, direction: direction });
      }, ANIM_SAFETY);
    }

    // ── Header appearance per section ──────
    function syncHeader() {
      if (!header) return;
      // Only the homepage hero suppresses the wordmark. Interior page heroes
      // retain the transparent/light header while keeping the logo visible.
      if (isHomepage && current === 0) {
        header.classList.remove('scrolled', 'dark-text', 'show-logo');
      } else if (current === 0) {
        header.classList.remove('scrolled', 'dark-text');
        header.classList.add('show-logo');
      } else {
        header.classList.add('scrolled', 'dark-text', 'show-logo');
      }
    }

    // ── Dot navigation ─────────────────────
    var dots = [];

    function buildDots() {
      var nav = document.createElement('nav');
      nav.className = 'fp-dots fp-dots--light';
      nav.setAttribute('aria-label', 'Scroll to section');

      sections.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fp-dot' + (i === 0 ? ' fp-dot--active' : '');
        btn.setAttribute('aria-label', 'Section ' + (i + 1));
        btn.addEventListener('click', function () { goTo(i); });
        nav.appendChild(btn);
        dots.push(btn);
      });

      document.body.appendChild(nav);
    }

    // ── Mobile scroll indicator ────────────
    var mobileIndicator = null;

    function buildMobileIndicator() {
      var indicator = document.createElement('div');
      indicator.className = 'mobile-scroll-indicator mobile-scroll-indicator--light';
      indicator.setAttribute('role', 'button');
      indicator.setAttribute('tabindex', '0');
      indicator.setAttribute('aria-label', 'Scroll to next section');

      var text = document.createElement('div');
      text.className = 'scroll-indicator-text';
      text.textContent = 'Swipe';

      var arrow = document.createElement('div');
      arrow.className = 'scroll-indicator-arrow';

      indicator.appendChild(text);
      indicator.appendChild(arrow);
      document.body.appendChild(indicator);

      indicator.addEventListener('click', function () {
        if (current < sections.length - 1) goTo(current + 1, 1);
      });

      indicator.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (current < sections.length - 1) goTo(current + 1, 1);
      });

      mobileIndicator = indicator;
    }

    function syncMobileIndicator() {
      if (!mobileIndicator) return;
      
      // Hide on last section
      if (current >= sections.length - 1) {
        mobileIndicator.classList.add('mobile-scroll-indicator--hidden');
      } else {
        mobileIndicator.classList.remove('mobile-scroll-indicator--hidden');
      }

      // Color based on section background
      var isLightIndicator = sectionUsesLightControls(sections[current]);
      mobileIndicator.classList.toggle('mobile-scroll-indicator--light', isLightIndicator);
      mobileIndicator.classList.toggle('mobile-scroll-indicator--dark', !isLightIndicator);
    }

    function sectionUsesLightControls(section) {
      if (!section) return false;

      if (
        section.classList.contains('hero-section') ||
        section.classList.contains('page-hero-section') ||
        section.classList.contains('site-footer') ||
        section.classList.contains('it-bg--green') ||
        section.classList.contains('values-bg--green')
      ) {
        return true;
      }

      var bgColor = window.getComputedStyle(section).backgroundColor;
      var match = bgColor && bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([.\d]+))?\)/);
      if (!match) return false;

      var alpha = match[4] === undefined ? 1 : parseFloat(match[4]);
      if (alpha < 0.5) return false;

      var r = parseInt(match[1], 10) / 255;
      var g = parseInt(match[2], 10) / 255;
      var b = parseInt(match[3], 10) / 255;
      var luminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);

      return luminance < 0.45;
    }

    function syncDots() {
      dots.forEach(function (d, i) {
        d.classList.toggle('fp-dot--active', i === current);
      });
      var nav = document.querySelector('.fp-dots');
      if (nav) {
        var lightDots = sectionUsesLightControls(sections[current]);
        nav.classList.toggle('fp-dots--light', lightDots);
        nav.classList.toggle('fp-dots--dark',  !lightDots);
        nav.classList.toggle('fp-dots--home-hero', isHomepage && current === 0);
      }
      syncMobileIndicator();
    }

    // ── Wheel handler ──────────────────────
    function onWheel(e) {
      var now = Date.now();
      var direction = e.deltaY > 0 ? 1 : -1;
      var timeSinceLastEvent = now - lastWheelEventTime;
      var sameGesture = timeSinceLastEvent < WHEEL_GESTURE_IDLE;
      lastWheelEventTime = now;
      if (!sameGesture) wheelSamples = [];

      var wheelValue = Math.abs(e.wheelDelta || -e.deltaY || -e.detail || e.deltaY || 0);
      wheelSamples.push(wheelValue);
      if (wheelSamples.length > WHEEL_SAMPLE_LIMIT) wheelSamples.shift();

      var section = sections[current];
      var sectionH = section.offsetHeight;
      var viewH    = viewportHeight();
      var debugData = {
        deltaY: e.deltaY,
        direction: direction,
        sameGesture: sameGesture,
        timeSinceLastEvent: timeSinceLastEvent,
        accelerating: isWheelAccelerating(),
        samples: wheelSamples.slice(-6),
        sinceLastWheel: now - lastWheelTime,
      };

      if (!sameGesture) {
        debugScroll('wheel:new-gesture', debugData);
      }

      // Tall sections opt into natural page scrolling. Regular page
      // sections may be slightly taller than the viewport because of padding,
      // but they should still behave as full-page snap panels.
      if (section.hasAttribute('data-fp-snap-tall')) {
        var sectionTop = Math.round(section.getBoundingClientRect().top + window.scrollY);
        var atTop = window.scrollY <= sectionTop + 8;
        var atBot = window.scrollY + viewH >= sectionTop + sectionH - 8;
        if (e.deltaY > 0 && !atBot) {
          debugScroll('wheel:natural-tall-down', debugData);
          return; // let natural scroll continue downward
        }
        if (e.deltaY < 0 && !atTop) {
          debugScroll('wheel:natural-tall-up', debugData);
          return; // let natural scroll continue upward
        }

        // Once natural scrolling reaches an edge, hand off directly to the
        // adjacent snap panel. Trackpad momentum heuristics are useful between
        // regular panels, but can otherwise reject every edge gesture here.
        e.preventDefault();
        if (animating) {
          debugScroll('wheel:block-tall-animating', debugData);
          return;
        }

        if (e.deltaY > 0 && atBot) {
          debugScroll('wheel:tall-next', debugData);
          lastWheelTime = now;
          goTo(current + 1, 1);
          return;
        }

        if (e.deltaY < 0 && atTop) {
          debugScroll('wheel:tall-previous', debugData);
          lastWheelTime = now;
          goTo(current - 1, -1);
          return;
        }
      }

      // Boundary: let scroll reach footer / page top naturally
      if (!animating && current === sections.length - 1 && e.deltaY > 0) {
        debugScroll('wheel:natural-end', debugData);
        return;
      }
      if (!animating && current === 0 && e.deltaY < 0) {
        debugScroll('wheel:natural-start', debugData);
        return;
      }

      e.preventDefault();
      if (animating) {
        debugScroll('wheel:block-animating', debugData);
        return;
      }
      if (now - lastWheelTime < WHEEL_GAP) {
        debugScroll('wheel:block-gap', debugData);
        return;
      }
      if (!isWheelAccelerating()) {
        debugScroll('wheel:block-decelerating', debugData);
        return;
      }
      lastWheelTime = now;
      debugScroll('wheel:snap', debugData);

      goTo(current + direction, direction);
    }

    // ── Touch handlers ─────────────────────
    function onTouchStart(e) {
      // Ignore multi-touch (pinch-zoom etc.)
      if (e.touches.length > 1) return;
      touchStartY     = e.touches[0].clientY;
      touchStartX     = e.touches[0].clientX;
      touchStartScrollY = window.scrollY;
      touchIsVertical = null;
      
      // Temporarily hide mobile indicator during touch
      if (mobileIndicator) {
        mobileIndicator.style.opacity = '0';
      }
    }

    function onTouchMove(e) {
      if (e.touches.length > 1) return;
      // Determine the primary axis on the first meaningful movement
      if (touchIsVertical === null) {
        var dy = Math.abs(touchStartY - e.touches[0].clientY);
        var dx = Math.abs(touchStartX - e.touches[0].clientX);
        if (dy > 5 || dx > 5) {
          touchIsVertical = dy >= dx;
        }
      }

      if (touchIsVertical !== true) return;

      var section  = sections[current];
      var sectionH = section.offsetHeight;
      var viewH    = viewportHeight();

      if (section.hasAttribute('data-fp-snap-tall')) {
        var sectionTop = Math.round(section.getBoundingClientRect().top + window.scrollY);
        var currentY = e.touches[0].clientY;
        var delta = touchStartY - currentY;
        var atTop = window.scrollY <= sectionTop + 8;
        var atBot = window.scrollY + viewH >= sectionTop + sectionH - 8;
        if (delta > 0 && !atBot) return;
        if (delta < 0 && !atTop) return;
      }

      e.preventDefault();
    }

    function onTouchEnd(e) {
      lastTouchEndTime = Date.now();
      
      // Show mobile indicator again after touch
      if (mobileIndicator) {
        mobileIndicator.style.opacity = '';
      }
      
      if (animating) return;
      if (!e.changedTouches.length) return;

      // Skip horizontal swipes (e.g. carousels, side-menus)
      if (touchIsVertical === false) return;

      var delta = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(delta) < 35) return;

      var section  = sections[current];
      var sectionH = section.offsetHeight;
      var viewH    = viewportHeight();

      if (section.hasAttribute('data-fp-snap-tall')) {
        var sectionTop = Math.round(section.getBoundingClientRect().top + window.scrollY);
        // Use a larger buffer on touch (5 % of viewport) to absorb iOS
        // momentum that can carry the scroll slightly past the boundary.
        var boundary = Math.max(16, viewH * 0.05);
        var startedAtTop = touchStartScrollY <= sectionTop + boundary;
        var startedAtBot = touchStartScrollY + viewH >= sectionTop + sectionH - boundary;
        if (delta > 0 && !startedAtBot) return;
        if (delta < 0 && !startedAtTop) return;
      }

      if (current === sections.length - 1 && delta > 0) return;
      if (current === 0 && delta < 0) return;
      goTo(current + (delta > 0 ? 1 : -1));
    }

    function onTouchCancel() {
      // Reset state so a cancelled gesture never accidentally triggers navigation
      touchStartY     = 0;
      touchStartX     = 0;
      touchIsVertical = null;
      
      // Show mobile indicator again after cancelled touch
      if (mobileIndicator) {
        mobileIndicator.style.opacity = '';
      }
    }

    // ── Keyboard handler ───────────────────
    function onKeyDown(e) {
      var tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault();
        goTo(current + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        goTo(current - 1);
      }
    }

    // ── Sync current after manual scroll ───
    // Uses scroll-position containment rather than proximity of section tops,
    // so that scrolling through a tall section never prematurely advances
    // `current` to the next section while the user is still inside the current one.
    var syncTimer;
    function onNativeScroll() {
      if (animating) {
        clearTimeout(syncTimer);
        clearTimeout(reSnapTimer);
        return;
      }

      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        var viewTop = window.scrollY;
        var viewBottom = viewTop + viewportHeight();
        var maxY = maxScrollY();
        var scrollMid = window.scrollY + viewportHeight() / 2;
        var best = 0;

        if (viewBottom >= document.documentElement.scrollHeight - 8 || viewTop >= maxY - 8) {
          best = sections.length - 1;
        } else {
        for (var i = 0; i < sections.length; i += 1) {
          var s = sections[i];
          var top = s.getBoundingClientRect().top + window.scrollY;
          var bottom = top + s.offsetHeight;

          // Tall sections own the scroll state until the viewport top has
          // actually left them. Using midpoint here can switch to the next
          // section too early and make later snaps jump backward.
          if (s.hasAttribute('data-fp-snap-tall') && viewTop >= top - 8 && viewTop < bottom - 8) {
            best = i;
            break;
          }

          // For regular panels, advance when the viewport midpoint has passed
          // this section's top.
          if (scrollMid >= top) best = i;
        }
        }

        if (best !== current) {
          current = best;
          syncHeader();
          syncDots();
        }
      }, 60);

      // After touch-driven scrolling (including iOS momentum), re-snap to the
      // nearest section once the page has been still for RESNAP_SETTLE ms.
      if (Date.now() - lastTouchEndTime < 3000) {
        var activeSection = sections[current];
        if (activeSection && activeSection.hasAttribute('data-fp-snap-tall')) {
          clearTimeout(reSnapTimer);
          return;
        }

        clearTimeout(reSnapTimer);
        reSnapTimer = setTimeout(function () {
          if (!animating) goTo(current);
        }, RESNAP_SETTLE);
      }
    }

    // ── Boot ───────────────────────────────
    buildDots();
    buildMobileIndicator();
    if (window.TeaAffairMotion) window.TeaAffairMotion.revealSection(sections[current]);
    syncDots();
    syncHeader();

    window.addEventListener('wheel',       onWheel,        { passive: false });
    window.addEventListener('touchstart',  onTouchStart,   { passive: true  });
    window.addEventListener('touchmove',   onTouchMove,    { passive: false });
    window.addEventListener('touchend',    onTouchEnd,     { passive: true  });
    window.addEventListener('touchcancel', onTouchCancel,  { passive: true  });
    document.addEventListener('keydown',   onKeyDown);
    window.addEventListener('scroll',      onNativeScroll, { passive: true  });

    document.addEventListener('fp-scroll:target', function (e) {
      var target = e.detail && e.detail.target;
      var index = sections.indexOf(target);
      if (index === -1) return;

      e.preventDefault();
      goTo(index);
    });
  }

  // ─────────────────────────────────────────
  // Boot everything on DOMContentLoaded
  // ─────────────────────────────────────────
  // ─────────────────────────────────────────
  // Header state for non-homepage templates
  // ─────────────────────────────────────────
  function initHeaderState() {
    var isHomepage      = document.body.classList.contains('template-index');
    var hasSnapSections = document.querySelectorAll('[data-fp-snap]').length > 0;
    var usesNativeLongForm = !!document.querySelector('.image-text-section--long');
    // Pages with full-page scroll snap (About, Journey) manage their own header
    if (isHomepage || (hasSnapSections && !usesNativeLongForm)) return;

    var header = document.querySelector('.site-header');
    if (!header) return;

    // Apply dark text + logo immediately so links are readable on light backgrounds.
    // Do NOT add 'scrolled' yet — that adds the border and background, which looks
    // cleaner to reveal only once the user actually scrolls.
    header.classList.add('dark-text', 'show-logo');

    function onScroll() {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once in case page is already scrolled on load
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initCartCount();
    initAjaxCart();
    initAnchorScroll();
    initNaturalWheelFallback();
    initStandardMotion();
    initHeaderState();
    initFullPageScroll();
  });

}());
